import * as CommonUtils from '@sparta.global.utilities/common-utils-utility/dist/es6.js';

const {
  isJqueryEl
} = CommonUtils;
function isPlainArray(el) {
  // Boolean.  Answers the Q of is this a plain array/indexed object
  return el && el.constructor === Array && !isJqueryEl(el) ? true : false;
}
function arrayDiff(array_a, array_b) {
  // give back an array of the non-matches
  const diffIndexes = [];
  return array_b.filter(i => {
    if (array_a.indexOf(i) < 0) {
      diffIndexes.push(array_b.indexOf(i));
      return true;
    } else {
      return false;
    }
  });
}

// arr1 = ['a', 'b', 22];  arr2 = ['22', '1', 'a', '3', 'b', 5, 'stuff'];  this evaluates to true
function areAllValuesInAnotherArray(arr1, arr2) {
  return arr1.every(val => isValueInArray(val, arr2));
}

// 'a' is in ['2', 'bb', 'a']
function isValueInArray(val, arr) {
  return arr.indexOf(val) !== -1;
}
function removeDuplicatesFromArray(arr) {
  return Array.from(new Set(arr));
}
function convertObjectToArray(obj) {
  return Object.keys(obj).map(key => obj[key]);
}

/**
 * Merge arrays
 * @params plain arrays of n quantity
 */
function reduceArrayMerge(...arrays) {
  return arrays.reduce((arr1, arr2) => Array.prototype.push.apply(arr1, arr2)); // merge plain arrays
}
function arrayValuesAreEqual(array) {
  return !!array.reduce((a, b) => a === b ? a : NaN);
}
const arrayToObject = (arr, keyField) => Object.assign({}, ...arr.map(item => ({
  [item[keyField]]: item
})));

export { areAllValuesInAnotherArray, arrayDiff, arrayToObject, arrayValuesAreEqual, convertObjectToArray, isPlainArray, isValueInArray, reduceArrayMerge, removeDuplicatesFromArray };
